import { Stack } from '@sixui/ui';
import { spacingTokens } from '@sixui/ui/themes/base/spacing.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IContentBlockInfoListProps = IContainerProps & {
  children: React.ReactNode;
  first?: boolean;
};

const styles = stylex.create({
  divider$first: {
    paddingTop: 0,
  },
  dl: {
    display: 'grid',
    gap: spacingTokens.padding$4,
    gridTemplateColumns: 'min-content 1fr',
    paddingBottom: '1.25rem',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
  },
  dl$first: {
    paddingTop: '1.25rem',
  },
});

export const ContentBlockInfoList: React.FC<IContentBlockInfoListProps> = (
  props,
) => {
  const { sx, children, first } = props;

  return (
    <Stack as="dl" gap={2} sx={[styles.dl, first && styles.dl$first, sx]}>
      {children}
    </Stack>
  );
};
